import React, { useState, useEffect, useLayoutEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { change, clearFields } from 'redux-form';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import Contract from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import {
  contractById,
  contractNextNumber,
  contractSave,
  contractTypeListByFilter,
  responsibleStudentRelationListByFinantialContact,
  studentListByFilter,
  financialGenerateByContract,
  saveFinancialSaveByContract,
  accountList,
  discountConfigurationByAccount,
  financialListByContract,
} from '../../../shared/queries/Contract';
import {
  STATUS_OPENED,
  STATUS_SELECTOR,
} from '../../../shared/utils/constants';
import FullScreenDialog from '../../../shared/components/FullScreenDialog';
import GeneratorTitles from './GeneratorTitles';
import { receivingCategoryListByFilter } from '../../../shared/queries/ReceivingCategory';
import { getUTCDateFromMilliseconds } from '../../../shared/utils/smartutils';

const ContractFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({
    id: 0,
    status: STATUS_SELECTOR.ACTIVE,
    products: [],
    initialDate: getUTCDateFromMilliseconds(new Date().getTime()),
    finalValidityDate: getUTCDateFromMilliseconds(new Date().getTime()),
    competencyDate: getUTCDateFromMilliseconds(new Date().getTime()),
    toGenerate: true,
  });
  const [formOn, setFormOn] = useState(false);
  const [responsibleFinancial, setResponsibleFinancial] = useState([]);
  const [titles, setTitles] = useState([]);
  const [contractType, setContractTypes] = useState([]);
  const [students, setStudents] = useState([]);
  const [titlesFullScreen, setTitlesFullScreen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [discountConfigurations, setDiscountConfigurations] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [smartpayConfigurations, setSmartPayConfigurations] = useState({
    applyDiscountConfiguration: false,
    inTestEnvironment: false,
  });
  const backClickHandler = () => {
    history.push('/minime/contrato');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const toggleTitles = () => {
    setTitlesFullScreen(!titlesFullScreen);
  };

  const loadAllTypeContracts = () => {
    const query = contractTypeListByFilter();
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.contractTypeListByFilter = res.contractTypeListByFilter.map(
          (item) => ({
            ...item,
            id: item.id,
            value: item.id,
            label: t(`${item.name}`),
          })
        );
        setContractTypes(res.contractTypeListByFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllStudents = () => {
    const query = studentListByFilter();
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.studentListByFilter = res.studentListByFilter.map((item) => ({
          ...item,
          id: item.id,
          value: item.id,
          label: t(`${item.fullName}`),
        }));
        setStudents(res.studentListByFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadResponsibleFinancial = (studentId) => {
    const query = responsibleStudentRelationListByFinantialContact(studentId);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.responsibleStudentRelationListByFinantialContact =
          res.responsibleStudentRelationListByFinantialContact.map((item) => ({
            ...item,
            id: item.responsible.id,
            value: item.responsible.id,
            label: t(`${item.responsible.fullName}`),
          }));
        setResponsibleFinancial(
          res.responsibleStudentRelationListByFinantialContact
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadContractNextNumber = () => {
    const query = contractNextNumber();
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        setDto({ ...dto, numberContract: res.contractNextNumber });
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllCategory = () => {
    const filter = {
      filterByStatus: false,
      updaterId: 0,
      active: true,
      id: 0,
    };
    const query = receivingCategoryListByFilter(filter);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        setCategories(res.receivingCategoryListByFilter);
        toggleTitles();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const smartPayAccount = (accs) => {
    const findSmartPay = accs.filter((acc) => acc.smartpay);
    if (findSmartPay.length !== 0) {
      const accountSmartpay = findSmartPay[0];
      const updatedSmartPayConf = {
        ...smartpayConfigurations,
        automaticBilling: true,
        fines: accountSmartpay.iuguAccountInfo.interestForDelay,
        latePaymentFine: accountSmartpay.iuguAccountInfo.interestRateForDelay,
        perDayInterest: accountSmartpay.iuguAccountInfo.dailyInterestForDelay,
        account: accountSmartpay,
      };
      setSmartPayConfigurations(updatedSmartPayConf);
    }
  };

  const loadAllAccount = () => {
    const query = accountList();
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.accountListByFilter = res.accountListByFilter.map((item) => ({
          ...item,
          value: item.id,
          label: item.name,
        }));
        setAccounts(res.accountListByFilter);
        smartPayAccount(res.accountListByFilter);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadGenerateByContract = (id) => {
    let query = financialGenerateByContract(dto.id);
    if (id) {
      query = financialGenerateByContract(id);
    }
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.financialGenerateByContract = res.financialGenerateByContract.map(
          (item) => ({ ...item, generate: true })
        );
        setTitles(res.financialGenerateByContract);
        loadAllCategory();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadTitlesListByContract = () => {
    const query = financialListByContract(dto);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        setTitles(res.financialListByContract);
        let apply = false;
        if (res.financialListByContract[0].discountConfigurations.length) {
          apply = true;
        }
        dispatch(change('generatorTitle', 'applyDiscountConfiguration', apply));
        setSmartPayConfigurations({
          ...smartpayConfigurations,
          applyDiscountConfiguration: apply,
        });
        loadAllCategory();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const screenTitles = () => {
    if (dto.toGenerate) {
      loadGenerateByContract();
    } else {
      loadTitlesListByContract();
    }
  };

  const loadDiscountConfigurationByAccount = (accountId) => {
    showLoading();
    const query = discountConfigurationByAccount(accountId);
    GraphQL(query, {})
      .then((res) => {
        res.discountConfigurationByAccount =
          res.discountConfigurationByAccount.map((item) => ({
            ...item,
            titleId: 0,
          }));
        setDiscountConfigurations(res.discountConfigurationByAccount);
        let apply = false;
        if (res.discountConfigurationByAccount.length) {
          apply = true;
        }
        dispatch(change('generatorTitle', 'applyDiscountConfiguration', apply));
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const findById = (id) => {
    showLoading();
    const query = contractById(id);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.contractListByFilter) {
          const contract = res.contractListByFilter[0];
          setDto({
            ...contract,
            competencyDate: getUTCDateFromMilliseconds(contract.competencyDate),
            initialDate: getUTCDateFromMilliseconds(contract.initialDate),
            finalValidityDate: contract.finalValidityDate
              ? getUTCDateFromMilliseconds(contract.finalValidityDate)
              : contract.finalDate,
            contractType: {
              ...contract.contractType,
              id: contract.contractType.id,
              name: contract.contractType.name,
              label: contract.contractType.name,
            },
            student: {
              ...contract.student,
              id: contract.student.id,
              label: contract.student.fullName,
            },
            responsible1: {
              ...contract.responsible1,
              id: contract.responsible1.responsible.id,
              label: contract.responsible1.responsible.fullName,
            },
            responsible2: contract.responsible2.responsible.fullName !==
              null && {
              ...contract.responsible2,
              id: contract.responsible2.responsible.id,
              label: contract.responsible2.responsible.fullNam,
            },
          });
          if (
            contract.toGenerate &&
            contract.status !== STATUS_SELECTOR.CANCELED
          ) {
            loadGenerateByContract(contract.id);
          }
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const handleSubmit = (values) => {
    const mutation = contractSave(values);
    showLoading();
    GraphQL(mutation, {})
      .then((res) => {
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        if (
          res.contractSave.status === STATUS_OPENED &&
          res.contractSave.toGenerate
        ) {
          history.push(`/minime/contrato/mnt/${res.contractSave.id}`);
          setDto({ ...dto });
          findById(res.contractSave.id);
          loadAllAccount();
        } else {
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const handleSubmitGenerate = (values) => {
    const mutation = saveFinancialSaveByContract(values);

    toggleTitles();
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        hideLoading();
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save-contract')
        );
      });
  };

  useLayoutEffect(() => {
    dispatch(
      clearFields(
        'ContractForm',
        true,
        true,
        ...['responsible1', 'responsible2']
      )
    );
  }, [responsibleFinancial]);

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        loadAllAccount();
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  useEffect(() => {
    if (dto.id === 0) {
      loadContractNextNumber();
    } else {
      loadAllAccount();
    }
    loadAllTypeContracts();
    loadAllStudents();
  }, []);

  return (
    <SmartCard title={t('screens.mnt_contratos.title')}>
      {formOn && (
        <>
          <Contract
            onSubmit={handleSubmit}
            backHandler={backClickHandler}
            dto={dto}
            contractType={contractType}
            students={students}
            responsibleFinancial={responsibleFinancial}
            loadResponsibleFinancial={loadResponsibleFinancial}
            toggleTitles={screenTitles}
          />
          <FullScreenDialog
            title={t('panels.titles-setup')}
            toggleDialog={toggleTitles}
            isOpen={titlesFullScreen}
            toggleBackDialog={toggleTitles}
          >
            <GeneratorTitles
              onSubmit={handleSubmitGenerate}
              dto={dto}
              titles={titles}
              categories={categories}
              accounts={accounts}
              smartpayConfigurations={smartpayConfigurations}
              discountConfigurations={discountConfigurations}
              setDiscountConfigurations={setDiscountConfigurations}
              loadDiscountConfigurationByAccount={
                loadDiscountConfigurationByAccount
              }
            />
          </FullScreenDialog>
        </>
      )}
    </SmartCard>
  );
};

ContractFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ContractFormHandler)
);
